var _excluded = ["children", "className", "component", "href", "onClick", "onKeyDown", "role", "selected", "disabled", "target", "twoLine"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import { useCombinedRefs } from "../../utils/hooks";
import { keyCodes } from "../../utils/helpers";
import "./AList.scss";
var AListItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    propsClassName = _ref.className,
    component = _ref.component,
    href = _ref.href,
    propsOnClick = _ref.onClick,
    _onKeyDown = _ref.onKeyDown,
    role = _ref.role,
    selected = _ref.selected,
    disabled = _ref.disabled,
    target = _ref.target,
    twoLine = _ref.twoLine,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(role),
    _useState2 = _slicedToArray(_useState, 2),
    roleValue = _useState2[0],
    setRoleValue = _useState2[1];
  var listItemRef = useRef(null);
  var combinedRef = useCombinedRefs(ref, listItemRef);
  var onClick = function onClick(e) {
    if (disabled) {
      return;
    }
    propsOnClick && propsOnClick(e);
  };
  useEffect(function () {
    if (!role && combinedRef.current && combinedRef.current.closest(".a-menu") !== null) {
      setRoleValue("menuitem");
    }
  }, [role, combinedRef, setRoleValue]);
  var className = "a-list-item";
  if (twoLine) {
    className += " a-list-item--two-line";
  }
  if (selected) {
    className += " a-list-item--selected";
  }
  if (disabled) {
    className += " a-list-item--disabled";
  }
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  var TagName = "div";
  var props = _objectSpread(_objectSpread({}, rest), {}, {
    ref: combinedRef,
    className: className,
    disabled: disabled,
    onClick: onClick,
    onKeyDown: function onKeyDown(e) {
      if (onClick && e.keyCode === keyCodes.enter) {
        e.preventDefault();
        onClick(e);
      }
      _onKeyDown && _onKeyDown(e);
    },
    role: roleValue
  });
  if (href) {
    TagName = "a";
    props.href = href;
    props.target = target;
  }
  if (href || onClick || component) {
    props.tabIndex = 0;
  }
  if (component) {
    TagName = component;
  }
  return /*#__PURE__*/React.createElement(TagName, props, children);
});
AListItem.propTypes = {
  /**
   * Sets the base component. Useful for integrating with routers.
   */
  component: PropTypes.elementType,
  /**
   * If specified, the component will render as an HTML link.
   */
  href: PropTypes.string,
  /**
   * Sets the [WAI-ARIA](https://www.w3.org/WAI/standards-guidelines/aria/) role.
   * If the role is not set, the component may infer this.
   */
  role: PropTypes.string,
  /**
   * Toggles the `selected` state.
   */
  selected: PropTypes.bool,
  /**
   * Toggles the `disabled` state.
   */
  disabled: PropTypes.bool,
  /**
   * If the `href` property is defined, the target can be set (ex: `_blank`, `_self`, `_parent`, `_top`)
   */
  target: PropTypes.string,
  /**
   * Toggles whether the list item has more than one line of text.
   */
  twoLine: PropTypes.bool
};
AListItem.displayName = "AListItem";
export default AListItem;